import {
  OrderPaymentType,
  SupplierInvoiceCreationStageType,
  SupplierRelationshipPaymentTermsType,
} from "@sellar-io/api-v2/types";

export const useInvoiceCreationStage = (parameters: {
  isBuyer: boolean;
  invoiceCreationStage: SupplierInvoiceCreationStageType;
  paymentType: OrderPaymentType | null;
  paymentTerms?: SupplierRelationshipPaymentTermsType | null;
}) => {
  const { isBuyer, invoiceCreationStage, paymentType, paymentTerms } =
    parameters;
  if (paymentType === "cardPaymentWithDeposit") {
    return "Invoice issued when card is charged remaining order amount";
  }
  if (!paymentTerms || paymentTerms === "proforma")
    return isBuyer
      ? `Invoice issued before finalisation`
      : `Issue invoice before finalisation`;
  if (paymentTerms === "paymentOnDelivery")
    return "Invoice issued automatically on finalisation";
  switch (invoiceCreationStage) {
    case "delivered":
      return "Invoice issued automatically on delivery";
    case "dispatched":
      return "Invoice issued automatically on dispatch";
    default:
      return `Invoice issued automatically on finalisation`;
  }
};
